import { StrictLocalizeFunction } from "@faire/web/common/localization";

// small class to help build the data structure.
class Value {
  constructor(
    public readonly title: string,
    public readonly description: string
  ) {}
}

const HEALTHCARE = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Comprehensive healthcare",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage:
        "Including Health, Dental, Vision, and Disability for all our locations.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const TIME_OFF = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Time off",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage:
        "Paid vacation time, holidays, and company-wide “Faire Fundays.”",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const PARENTAL_LEAVE = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Parental leave",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage:
        "Generous parental and family leave, as well as fertility support benefits.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const MINDFULNESS = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Daily mindfulness",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage: "Optional morning meditation.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const LEARNING = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Annual learning grant",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage: "For personal and professional development.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const SPACES = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Thoughtfully designed spaces",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage:
        "All of our offices have been designed with local in mind—from our architects to our coffee blends.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const WELLBEING = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Fitness & wellbeing benefits",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage:
        "Including a monthly credit toward your wellness-related programs.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const MENTAL_HEALTH = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Mental health benefits",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage:
        "Including free access to Modern Health therapists and resources.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const CHARITABLE = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Charitable matching",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage:
        // eslint-disable-next-line @faire/no-dollar-symbol-in-strings
        "Faire will match up to US$250 of your charitable donations, every year.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

const CAREER = (strictLocalize: StrictLocalizeFunction) =>
  new Value(
    strictLocalize({
      defaultMessage: "Career planning",
      description: {
        text: "Title of a benefit in a list of employee benefits given by the company",
      },
    }),
    strictLocalize({
      defaultMessage:
        "Whether you want to grow as a leader, hone your craft, or explore a new discipline, our career framework allows space for you to explore.",
      description: {
        text: "Description of a benefit in a list of employee benefits given by the company",
      },
    })
  );

export const FAIRE_BENEFITS = (strictLocalize: StrictLocalizeFunction) =>
  [
    HEALTHCARE(strictLocalize),
    TIME_OFF(strictLocalize),
    PARENTAL_LEAVE(strictLocalize),
    MINDFULNESS(strictLocalize),
    LEARNING(strictLocalize),
    SPACES(strictLocalize),
    WELLBEING(strictLocalize),
    MENTAL_HEALTH(strictLocalize),
    CHARITABLE(strictLocalize),
    CAREER(strictLocalize),
  ] as const;
